import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-857c6de0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-testing"]
const _hoisted_2 = { class: "modal-card-header" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "modal-card-content" }
const _hoisted_5 = {
  key: 0,
  class: "modal-card-footer"
}

import { PropType, ref } from "vue";
import { mdiClose } from "@mdi/js";


export default /*#__PURE__*/_defineComponent({
  __name: 'Popup',
  props: {
  width: {
    required: false,
    type: Number,
    default: 960
  },
  modalCardClasses: {
    required: false,
    type: Array as PropType<string[]>,
    default: () => []
  },
  dataTestingModalCard: {
    required: false,
    type: String,
    default: ""
  },
  canCancel: {
    required: false,
    default: true,
    type: Boolean
  }
},
  emits: ["closePopup"],
  setup(__props) {

const isModalOpen = ref<boolean>(true);




return (_ctx: any,_cache: any) => {
  const _component_SVGIcon = _resolveComponent("SVGIcon")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_component_b_modal, {
      "model-value": isModalOpen.value,
      "has-modal-card": true,
      "trap-focus": true,
      "aria-role": "dialog",
      "aria-modal": true,
      "can-cancel": __props.canCancel,
      width: __props.width,
      class: "full-screen-modal",
      onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closePopup')))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(['modal-card', ...__props.modalCardClasses]),
          "data-testing": __props.dataTestingModalCard
        }, [
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "header"),
            _createElementVNode("button", {
              disabled: !__props.canCancel,
              type: "button",
              class: "close-btn btn-3",
              title: "close",
              "aria-label": "close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closePopup')))
            }, [
              _createVNode(_component_SVGIcon, {
                path: _unref(mdiClose),
                type: "is-white",
                size: 24
              }, null, 8, ["path"])
            ], 8, _hoisted_3)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "body")
          ]),
          (_ctx.$slots.footer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "footer")
              ]))
            : _createCommentVNode("", true)
        ], 10, _hoisted_1)
      ]),
      _: 3
    }, 8, ["model-value", "can-cancel", "width"])
  ]))
}
}

})